import { render } from "./UserGrid.vue?vue&type=template&id=1b304c84"
import script from "./UserGrid.vue?vue&type=script&lang=js"
export * from "./UserGrid.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__